import { ReactNode } from 'react';
import cl from 'clsx';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  PopoverPortal,
} from '@radix-ui/react-popover';

import { PopoverArrowSVGIcon } from '@/shared/assets';

import classes from './ClickPopover.module.scss';

export type ClickPopoverProps = {
  // className?: string;
  children: ReactNode;
  message: ReactNode;
};
export const ClickPopover = ({
  children,
  message,
  // className,
}: ClickPopoverProps) => {
  let messageNode: ReactNode = message;
  if (typeof message === 'string') {
    messageNode = <p>{message}</p>;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverPortal>
        <PopoverContent
          // style={contentStyle}
          className={cl(
            classes.content,
            'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 w-72 origin-[--radix-popover-content-transform-origin] rounded-md border bg-white p-4 outline-none',
            'relative w-[161px] text-pretty border p-2 text-center text-[10px] leading-[14px] shadow-md',
          )}
          side="top"
        >
          {messageNode}
          <PopoverArrowSVGIcon className="absolute bottom-0 left-[73px] translate-y-full" />
          {/* <PopoverArrow
                          className="disable-tooltip-arrow relative top-[-1px] fill-white"
                          height={9}
                          width={15}
                      /> */}
        </PopoverContent>
      </PopoverPortal>
    </Popover>
  );
};
